module.exports = __webpack_public_path__ + "static/img/101593.636f279a.png";